// extracted by mini-css-extract-plugin
export var errorIcon = "_n2-1";
export var nameLogo = "_n2-0";